import React from 'react';
import "@/sass/header.scss";
import menu from 'config/menu';

interface IProps {
    active: string,
    onClick: (url: string) => void
}

class List extends React.Component<IProps> {

    render() {
        return (
            <ul className="navbar-nav menu-list">
                { menu.map((m) => {
                    const handleClick = (e: any) => {
                        e.preventDefault()
                        this.props.onClick(e.target.href)
                    }
                    return (
                        <li className={`nav-item ${this.props.active == m.key ? 'active' : ''}`} key={m.key}>
                            <a className="menu-item nav-link" href={`#${m.key}`} onClick={handleClick}>{m.label}</a>
                        </li>
                    )
                })}
            </ul>
        )
    }
}

export default List